import { Injectable, inject } from '@angular/core'
import { KpiMetric, TransitTypeE } from '@tradecafe/types/core'
import { KpiMetricsApiService } from 'src/api/kpi-metrics'

@Injectable({ providedIn: 'root' })
export class KpiMetricsService {
  private KpiMetricsApi = inject(KpiMetricsApiService)


  getTruckKpis(): Promise<KpiMetric[]> {
    return this.KpiMetricsApi.getKpiMetrics({ type: TransitTypeE.land })
  }

  getOceanKpis(): Promise<KpiMetric[]> {
    return this.KpiMetricsApi.getKpiMetrics({ type: TransitTypeE.sea })
  }
}
